// 文件废弃
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDuration } from '@/biz/time';
import Radio from '@/components/Radio/index';
import { InfluencerAgreement } from '@/components/campaign/influencerAgreement';
import { isMobile, reviewTime } from '@/biz/tool';
import Modal from '@/components/web/components/Modal';
import BottomDrawer from './BottomDrawer';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import {
  JoinDrawEmaiIcon,
  JoinDrawClockIcon,
  JoinDrawFrontPaymentIcon,
  ScriptIcon,
  DedicatedVideoFilledIcon
} from '../../common/icon';
import { getFrontPaymentRate } from '../../../pages/campaign/config';
import styles from './interestContent.module.less';
import { AdsPlatform } from '@/interface/order';
import { useMultiplePricesStore } from '@/hooks/useMultiplePricesStore';
import { normalizePrice } from '@/utils/normalizePrice';
import PriceDetails from '@/components/web/components/PriceDetails';
import { AdsCampaignMarketingStrategy } from '@/interface/campaign';
import { NationsLab } from '@/utils/locations';
import { ProductType, ProductPhysicalSelectEnum } from '../config';

interface Props {
  setShowAnInterestOpen?: Function;
}

const initialScriptDraftDeadline = (hours: number | null) => {
  if (hours) return getDuration(hours);
  return '-';
};

const InterestContent: React.FC<Props> = ({ setShowAnInterestOpen }) => {
  const { t } = useTranslation();
  const { selectedPriceFields, inputPrice } = useMultiplePricesStore();

  const { detailData } = useDetailDataStore();
  const { order, timeline, product, campaign } = detailData;
  const rate = getFrontPaymentRate(order?.prepaymentRate);
  const {
    skipScript,
    setSkipScript,
    isAgree,
    setIsAgree,
    isShowAgreement,
    setIsShowAgreement,
    agreeProductShip,
    setAgreeProductShip
  } = useWebModalStore();

  const locations = detailData?.campaign?.locations || [];
  const countries = locations
    ?.map((item: string[]) => NationsLab?.[item?.[1]])
    ?.join(', ');
  const isProductShip =
    product?.productType === ProductType.PHYSICAL_PRODUCT &&
    product?.physicalProductShipType === ProductPhysicalSelectEnum.ship;
  useEffect(() => {
    if (
      !(
        detailData?.order?.marketingStrategy ===
          AdsCampaignMarketingStrategy.INFLUENCER_MARKETING &&
        order?.platform === AdsPlatform.Youtube &&
        !campaign?.isTrendCampaign
      )
    ) {
      setSkipScript(true);
    }
  }, [detailData, order, campaign?.isTrendCampaign]);

  return (
    <div className={isMobile() ? styles.container : styles.webContainer}>
      <div
        style={{
          display:
            detailData?.order?.campaignMarketingStrategy ===
            AdsCampaignMarketingStrategy.INFLUENCER_MARKETING
              ? 'flex'
              : 'none'
        }}
        className="mb-6 text-[#60646c] text-sm font-normal font-['Inter'] flex-col gap-2"
      >
        {order?.platform === AdsPlatform.Youtube && (
          <div className="justify-start text-[#1c2024] text-base font-semibold font-['Plus_Jakarta_Sans'] leading-snug">
            {t('interest.collaboration.select_method', {
              defaultValue: 'Please select your preferred collaboration method:'
            })}
          </div>
        )}
        <div>
          {order?.platform === AdsPlatform.Youtube ? (
            <>
              {t('interest.script.submit_time_prefix', {
                defaultValue:
                  'If approved, please submit your script draft within '
              })}
              <span className={styles.timeText}>
                {initialScriptDraftDeadline(
                  timeline?.initialScriptDraft?.maxWaitInHours
                )}{' '}
              </span>
              {t('interest.script.submit_time_suffix', {
                defaultValue: 'of approval.'
              })}
            </>
          ) : (
            <>
              {t('interest.draft.submit_time_prefix', {
                defaultValue: 'If approved, please submit your draft within '
              })}
              <span className={styles.timeText}>
                {initialScriptDraftDeadline(
                  timeline?.firstVideoDraft?.maxWaitInHours
                )}{' '}
              </span>
              {t('interest.draft.submit_time_suffix', {
                defaultValue: 'of approval.'
              })}
            </>
          )}
        </div>
        {/* <div className="self-stretch justify-start text-[#60646c] text-sm font-normal font-['Inter'] leading-snug">
          If approved, please submit your script within 2 days after application
          approval.
        </div> */}
      </div>
      <div
        className={`
          ${isMobile() ? 'gap-2 flex flex-col' : 'gap-8 flex'}
        `}
      >
        {(!detailData?.order?.marketingStrategy ||
          detailData?.order?.marketingStrategy ===
            AdsCampaignMarketingStrategy.INFLUENCER_MARKETING) &&
        order?.platform === AdsPlatform.Youtube &&
        !campaign?.isTrendCampaign ? (
          <>
            <div
              className={`w-full p-4 bg-white rounded-2xl border-2 flex flex-col gap-4 cursor-pointer
            ${!skipScript ? 'border-[#5a31f0]' : 'border-[#e0e0e0]'}
            ${isMobile() ? '!p-3' : ''}
            `}
              onClick={() => {
                if (skipScript) {
                  setSkipScript(false);
                }
              }}
            >
              <div className="flex justify-between items-center gap-2">
                <ScriptIcon
                  className={`w-6 h-6 ${!skipScript ? 'text-[#5B3DE9]' : ''}`}
                />
                <Radio checked={!skipScript} />
              </div>
              <div className="flex flex-col gap-2">
                <div
                  className="text-[#1c2024] font-semibold font-['Plus Jakarta Sans'] leading-normal"
                  style={{
                    fontSize: isMobile() ? '14px' : '16px'
                  }}
                >
                  {t('interest.script.create_title', {
                    defaultValue: 'I would like to create a script.'
                  })}
                </div>
                <div
                  className="text-[#1c2024] font-normal font-['Plus Jakarta Sans'] leading-snug"
                  style={{
                    fontSize: isMobile() ? '12px' : '14px'
                  }}
                >
                  {t('interest.script.create_description', {
                    defaultValue:
                      'Creating a script for your video ensures that key concepts and creative directions are aligned with your brand.'
                  })}
                </div>
              </div>
            </div>
            <div
              className={`w-full p-4 bg-white rounded-2xl border-2 flex flex-col gap-4 cursor-pointer
            ${skipScript ? 'border-[#5a31f0]' : 'border-[#e0e0e0]'}
            ${isMobile() ? '!p-3' : ''}
            `}
              onClick={() => {
                if (!skipScript) {
                  setSkipScript(true);
                }
              }}
            >
              <div className="flex justify-between items-center gap-2">
                <DedicatedVideoFilledIcon
                  className={`w-6 h-6 ${skipScript ? 'text-[#5B3DE9]' : ''}`}
                />
                <Radio checked={skipScript} />
              </div>
              <div className="flex flex-col gap-2">
                <div
                  className="text-[#1c2024] font-semibold font-['Plus Jakarta Sans'] leading-normal"
                  style={{
                    fontSize: isMobile() ? '14px' : '16px'
                  }}
                >
                  {t('interest.script.skip_title', {
                    defaultValue: 'I would like to skip the script.'
                  })}
                </div>
                <div
                  className="text-[#1c2024] font-normal font-['Plus Jakarta Sans'] leading-snug"
                  style={{
                    fontSize: isMobile() ? '12px' : '14px'
                  }}
                >
                  {t('interest.script.skip_description', {
                    defaultValue:
                      'You can forgo the scripting process and provide your video draft directly to the brand for feedback.'
                  })}
                </div>
              </div>
            </div>
          </>
        ) : (
          <div
            className={`w-full p-4 bg-white rounded-2xl border-2 flex flex-col gap-4 cursor-pointer
            ${skipScript ? 'border-[#5a31f0]' : 'border-[#e0e0e0]'}
            ${isMobile() ? '!p-3' : ''}
            `}
            onClick={() => {
              if (!skipScript) {
                setSkipScript(true);
              }
            }}
          >
            <div className="flex justify-between items-center gap-2">
              <DedicatedVideoFilledIcon
                className={`w-6 h-6 ${skipScript ? 'text-[#5B3DE9]' : ''}`}
              />
              <Radio checked={skipScript} />
            </div>
            <div className="flex flex-col gap-2">
              <div
                className="text-[#1c2024] font-semibold font-['Plus Jakarta Sans'] leading-normal"
                style={{
                  fontSize: isMobile() ? '14px' : '16px'
                }}
              >
                {t('interest.script.dont_need_to_create_script', {
                  defaultValue: "You don't need to create a script."
                })}
              </div>
              <div
                className="text-[#1c2024] font-normal font-['Plus Jakarta Sans'] leading-snug"
                style={{
                  fontSize: isMobile() ? '12px' : '14px'
                }}
              >
                {t('interest.script.no_script_needed_for_this_deal', {
                  defaultValue: 'No script is needed for this deal'
                })}
              </div>
            </div>
          </div>
        )}
      </div>

      <PriceDetails isModal={true} order={order} product={product} />
      <div
        className="h-[0] w-full bg-[#e8e8ec] mt-6 mb-4"
        style={{
          display: order?.platform === AdsPlatform.Youtube ? 'flex' : 'none'
        }}
      ></div>

      {!isMobile() ? (
        <div className={styles.agree}>
          <Radio
            checked={isAgree}
            onClick={() => {
              setIsAgree(!isAgree);
            }}
          />
          <span className="ml-1">
            {t('interest.agreement.consent_prefix', {
              defaultValue: "I consent to Head's"
            })}{' '}
          </span>
          <span
            className={styles.linkText}
            onClick={() => setIsShowAgreement(!isShowAgreement)}
          >
            {t('interest.agreement.creator_agreement', {
              defaultValue: 'Creator Agreement'
            })}
          </span>
          .
        </div>
      ) : null}
      {!isMobile() && isProductShip ? (
        <div className={`${styles.agree} mt-4`}>
          <Radio
            checked={agreeProductShip}
            onClick={() => {
              setAgreeProductShip(!agreeProductShip);
            }}
          />
          <span className="ml-1">
            {t('interest.product.location_confirm', {
              defaultValue:
                "I confirm I'm located in the following countries in order to receive the product:",
              countries
            })}{' '}
            {countries}
          </span>
        </div>
      ) : null}
      {/* {JSON.stringify(selectedPriceFields)} */}

      {isMobile() ? (
        <BottomDrawer
          visible={isShowAgreement}
          isShowFooter={false}
          isShowHeader={false}
          rootStyle={{ zIndex: 9999 }}
        >
          <InfluencerAgreement setIsShowAgreement={setIsShowAgreement} />
        </BottomDrawer>
      ) : (
        <Modal
          visible={isShowAgreement}
          isShowFooter={false}
          isShowHeader={false}
        >
          <InfluencerAgreement setIsShowAgreement={setIsShowAgreement} />
        </Modal>
      )}
    </div>
  );
};

export default InterestContent;
